import { publicaColors } from '~/src/dash/utils/colors';

export const determinePillBGColor = (
  isDisabled: boolean,
  isActive: boolean,
  isOpen: boolean,
  isHovered: boolean,
  defaultBGColor: string,
  hoverBGColor: string,
): string => {
  switch (true) {
    case isDisabled:
      return publicaColors.lightGray;
    case isActive:
      return publicaColors.honeydew;
    case isOpen:
    case isHovered:
      return hoverBGColor;
    default:
      return defaultBGColor;
  }
};

export const determinePillTextColor = (
  isDisabled: boolean,
  isActive: boolean,
  isOpen: boolean,
  isHovered: boolean,
  defaultTextColor: string,
  hoverTextColor: string,
): string => {
  switch (true) {
    case isDisabled:
      return publicaColors.gray;
    case isActive:
      return publicaColors.jungleGreen;
    case isOpen:
    case isHovered:
      return hoverTextColor;
    default:
      return defaultTextColor;
  }
};
